import $ from "jquery";
import ScrollOut from "scroll-out";

$(function () {
    var counter = parseFloat($('#number').text().replace(/,/g, '')); 
    var timeRemaining = 30000;

    var interval = setInterval(function () {
        counter += 0.1;

        $('#number').text(
            counter % 1 === 0 
                ? counter.toLocaleString()
                : counter.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) 
        );

        if (--timeRemaining <= 0) {
            clearInterval(interval);
        }
    }, 10);

    ScrollOut({
        onShown: function (element) {
            $('.counter').each(function () {
                var $this = $(this),
                    countTo = parseFloat($this.attr('data-count'));

                $({ countNum: parseFloat($this.text().replace(/,/g, '')) }).animate(
                    { countNum: countTo },
                    {
                        duration: 8000,
                        easing: 'linear',
                        step: function () {
                            $this.text(
                                this.countNum % 1 === 0 
                                    ? this.countNum.toLocaleString() 
                                    : this.countNum.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 })
                            );
                        },
                        complete: function () {
                            $this.text(
                                countTo % 1 === 0 
                                    ? countTo.toLocaleString() 
                                    : countTo.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 })
                            );
                        }
                    }
                );
            });
        },
    });
});
